// @ts-check
import React from "react"
import { numberFormatter } from "../../../utils/numbers.utils"
import { TimeDifferenceBadge } from "../CellReportBadges.molecule"
import { isHolidayAvailable } from "../../../utils/vacation.utils"
import { isTaskReportItem } from "../../../utils/report.utils"

/**
 * @param {import("./TimeDifferenceCell.molecule").TimeDifferenceCellProps<import("../../../services/reports.service.types").AnyTaskReportItem>} props
 * @returns {JSX.Element | null}
 */

export function TimeDifferenceCell(props) {
  const { ctx, teamMemberSchemaRules, teamMemberWorkAnniversaryDate } = props
  const { row, getValue } = ctx
  const rowData = row.original
  const timeDifference = getValue()

  const isTask = isTaskReportItem(rowData)
  const isGrouped = row.getIsGrouped()

  let isHolidayUnlocked = false

  if (isTask && "isHoliday" in rowData) {
    isHolidayUnlocked =
      teamMemberSchemaRules && teamMemberWorkAnniversaryDate ?
        isHolidayAvailable({
          idTypeOfHoliday: rowData?.idTypeOfHoliday,
          idHolidaySchemaType: rowData?.holidaySchemaType,
          teamMemberSchemaRules,
          isHoliday: rowData?.isHoliday,
          workAnniversaryDate: teamMemberWorkAnniversaryDate,
          currentDate: rowData?.date,
        })
      : false
  }

  const isDayOff =
    ("isVacationDay" in rowData && rowData?.isVacationDay) || isHolidayUnlocked

  const displayValue =
    isDayOff && timeDifference === 0 ? "-" : numberFormatter(timeDifference)

  const showBadge =
    isTask && rowData.billedTime !== rowData.sisuTime && !isGrouped

  const isNA =
    timeDifference === null ||
    (!isGrouped && isTask && !rowData.clientIsBillable)

  return (
    <div className="flex gap-1 w-4rem justify-content-between">
      {isNA ?
        <span className="opacity-30">N/A</span>
      : <span className={isGrouped ? "font-bold" : ""}>{displayValue}</span>}

      {showBadge && (
        // @ts-expect-error
        <TimeDifferenceBadge
          value={timeDifference}
          minTreshold={0}
          maxTreshold={0}
          referenceValue={0}
          position="left"
          tooltip={
            rowData.timeDifferenceComment ?
              `Motivo: ${rowData.timeDifferenceComment}`
            : "Sin comentarios"
          }
        />
      )}
    </div>
  )
}
